import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { filter, firstValueFrom, timeout } from 'rxjs';

export const adminGuard = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  try {
    // Wait for the user profile to be loaded from the backend
    const userData = await firstValueFrom(
      authService.userProfile$.pipe(
        filter(profile => profile !== undefined), // Wait until we have a profile (or failure/null)
        timeout(5000) // Timeout after 5 seconds
      )
    );

    if (userData?.role === 'aarvya_admin') {
      return true;
    }

    // Not an admin or no profile found, redirect to home
    return router.createUrlTree(['/home']);
  } catch (error) {
    console.error('AdminGuard error or timeout:', error);
    // On error/timeout, check if we even have a firebase user
    const firebaseUser = authService.currentUserValue;
    if (!firebaseUser) {
      return router.createUrlTree(['/sign-in']);
    }
    return router.createUrlTree(['/home']);
  }
};
